import axios from "axios";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

export default function OrderDetail() {
  const [order, setOrder] = useState([]);
  const { id } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    axios
      .get("https://dealersonly.parts/beta/api/user/orders/" + id)
      .then((res) => {
        setOrder(res.data);
      })
      .catch((error) => {
        navigate("../../");
      });
  }, []);

  console.log(order);

  // const html = document.getElementsByTagName("html")[0];
  // useEffect(() => {
  //   html.classList.remove("bg-gray-100")
  //   html.classList.add("bg-white")
  //   return () => {
  //     document.body.classList.remove('bg-gray-100');
  //   }
  // }, [])

  const confirmOrder = () => {
    axios
      .post("https://dealersonly.parts/beta/api/orders/confirm", { id: id }, {})
      .then((res) => {
        navigate("../../");
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const denyOrder = () => {
    axios
      .post("https://dealersonly.parts/beta/api/orders/cancel", { id: id }, {})
      .then((res) => {
        navigate("../../");
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const formatter = new Intl.NumberFormat("de-DE", {
    style: "currency",
    currency: "EUR",
  });

  const tax = order[0]?.gesamt * 1.19 - order[0]?.gesamt;

  const dateObject = new Date(parseInt(order[0]?.orderDate));
  const date =
    dateObject.toLocaleString("de-DE", {
      timeZone: "Europe/Berlin",
      day: "numeric",
      month: "long",
      year: "numeric",
    }) +
    " um " +
    dateObject.toLocaleString("de-DE", {
      timeZone: "Europe/Berlin",
      hour: "numeric",
      minute: "numeric",
    });

  return (
    <div className="bg-white">
      {order[0] && (
        <div className="max-w-7xl">
          <h1 className="text-3xl font-bold tracking-tight text-gray-900">
            Bestelldetails
          </h1>

          <div className="mt-2 border-b border-gray-200 pb-5 text-sm sm:flex sm:justify-between">
            <dl className="flex">
              <dt className="text-gray-500">Bestellnummer&nbsp;</dt>
              <dd className="font-medium text-gray-900">
                {order[0].customOrderNum}
              </dd>
              <dt>
                <span className="sr-only">Datum</span>
                <span className="mx-2 text-gray-400" aria-hidden="true">
                  &middot;
                </span>
              </dt>
              <dd className="font-medium text-gray-900">
                <time dateTime="2021-03-22">{date}</time>
              </dd>
            </dl>

            {order[0].status !== true && (
              <div className="flex flex-wrap sm:flex-nowrap gap-4">
                <div className="mt-4 sm:mt-0">
                  <button
                    type="button"
                    onClick={() => confirmOrder()}
                    className="font-medium text-green-600 hover:text-green-500"
                  >
                    Bestellung bestätigen
                    <span aria-hidden="true"> &rarr;</span>
                  </button>
                </div>
                <div className="mt-4 sm:mt-0">
                  <button
                    type="button"
                    onClick={() => denyOrder()}
                    className="font-medium text-red-600 hover:text-red-500"
                  >
                    Bestellung ablehnen
                    <span aria-hidden="true"> &rarr;</span>
                  </button>
                </div>
              </div>
            )}
          </div>

          <div className="mt-8">
            <h2 className="sr-only">Bestellter Artikel</h2>

            <div className="space-y-24">
              <div
                key={order[0].id}
                className="grid grid-cols-1 text-sm sm:grid-cols-12 sm:grid-rows-1 sm:gap-x-6 md:gap-x-8 lg:gap-x-8"
              >
                <div className="sm:col-span-4 md:col-span-5 md:row-span-2 md:row-end-2">
                  <div className="aspect-w-1 aspect-h-1 overflow-hidden rounded-lg bg-gray-50">
                    <img
                      src={
                        order[1].productImages &&
                        order[1].productImages[0] &&
                        order[1].productImages[0] !== ""
                          ? `https://dealersonly.parts/beta/app/${order[1].productImages[0]}`
                          : `https://dealersonly.parts/beta/app/files/DopePlaceholder.png`
                      }
                      alt="Artikelbild"
                      className="object-cover object-center"
                    />
                  </div>
                </div>
                <div className="mt-6 sm:col-span-7 sm:mt-0 md:row-end-1">
                  <h3 className="text-lg font-medium text-gray-900">
                    <a href={order[1].handle}>{order[1].title}</a>
                  </h3>
                  <p className="mt-1 font-medium text-gray-900">
                    {formatter.format(order[0].gesamt)}
                  </p>
                  <p className="mt-3 text-gray-500">{order[0].description}</p>
                </div>
                <div className="sm:col-span-12 md:col-span-7">
                  <dl className="grid grid-cols-1 gap-y-8 border-b border-gray-200 py-8 sm:grid-cols-2 sm:gap-x-6 sm:py-6 md:py-10">
                    <div>
                      <dt className="font-medium text-gray-900">
                        Lieferadresse
                      </dt>
                      <dd className="mt-3 text-gray-500">
                        <span className="block">
                          {order[0].rechnungsadresse.name}
                        </span>
                        <span className="block">
                          {order[0].rechnungsadresse.first_name}{" "}
                          {order[0].rechnungsadresse.last_name}
                        </span>
                        <span className="block">
                          {order[0].rechnungsadresse.street}
                        </span>
                        <span className="block">
                          {order[0].rechnungsadresse.plz}{" "}
                          {order[0].rechnungsadresse.ort}
                        </span>
                      </dd>
                    </div>
                    <div>
                      <dt className="font-medium text-gray-900">
                        Statusaktualisierungen
                      </dt>
                      <dd className="mt-3 space-y-3 text-gray-500">
                        <p>{order[0].email}</p>
                      </dd>
                    </div>
                  </dl>
                  <p className="mt-6 font-medium text-gray-900 md:mt-10">
                    {order[0].status ? "Versendet" : "Wird bearbeitet"}
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Billing */}
          <div className="mt-24">
            <h2 className="sr-only">Rechnungsdetails</h2>

            <div className="rounded-lg bg-gray-50 py-6 px-6 lg:grid lg:grid-cols-12 lg:gap-x-8 lg:px-0 lg:py-8">
              <dl className="grid grid-cols-1 gap-6 text-sm sm:grid-cols-2 md:gap-x-8 lg:col-span-8 lg:pl-8">
                <div>
                  <dt className="font-medium text-gray-900">
                    Verkäuferinformationen
                  </dt>
                  <dd className="mt-3 text-gray-500">
                    <span className="block">{order[0].sellerInfo.name}</span>
                    <span className="block">
                      {order[0].sellerInfo.first_name}{" "}
                      {order[0].sellerInfo.last_name}
                    </span>
                    <span className="block">{order[0].sellerInfo.street} </span>
                    <span className="block">
                      {order[0].sellerInfo.plz} {order[0].sellerInfo.ort}
                    </span>
                  </dd>
                </div>
                <div>
                  <dt className="font-medium text-gray-900">
                    Zahlungsanweisungen
                  </dt>
                  <dd className="mt-3 flex">
                    <div className="">
                      <p className="text-gray-900">
                        Zahlungsdetails dem Käufer mitteilen
                      </p>
                      <p className="text-gray-600">
                        Zahlungsaufforderung senden
                      </p>
                    </div>
                  </dd>
                </div>
              </dl>

              <dl className="mt-8 divide-y divide-gray-200 text-sm lg:col-span-4 lg:mt-0 lg:pr-8">
                <div className="flex items-center justify-between pb-4">
                  <dt className="text-gray-600">Zwischensumme</dt>
                  <dd className="font-medium text-gray-900">
                    {formatter.format(order[0].gesamt)}
                  </dd>
                </div>
                <div className="flex items-center justify-between py-4">
                  <dt className="text-gray-600">Steuer</dt>
                  <dd className="font-medium text-gray-900">
                    {formatter.format(tax)}
                  </dd>
                </div>
                <div className="flex items-center justify-between pt-4">
                  <dt className="font-medium text-gray-900">Gesamt</dt>
                  <dd className="font-medium text-indigo-600">
                    {formatter.format(order[0].gesamt + tax)}
                  </dd>
                </div>
              </dl>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
